import React, { useState } from 'react';
import { Card, Badge, Dropdown } from 'react-bootstrap';
import { Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FaShareAlt, FaFacebook, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import './TalentAuditionCard.css'

export const TalentAuditionCard = ({ audition }) => {
  const [showShare, setShowShare] = useState(false);


  const getResultClassName = (result) => {
    const val = String(result || 'Pending').toLowerCase();
    return `custom-result-badge badge-${val}`;
  };

  const stopOnly = (e) => e?.stopPropagation?.();
  
  const isWalkIn =
  audition?.booking_type === 'SLOT_BOOKING';

  const isOnline =
    audition?.booking_type === 'VIDEO_UPLOAD';

  /* STEP 1 */
  const step1Active = true;

  /* STEP 2 */
  
  const step2Active =
  isWalkIn
    ? (
        audition?.booking_status === 'BOOKED' ||
        audition?.result === 'SELECTED'
      )
    : (
        audition?.video_uploaded ||
        audition?.result === 'SELECTED'
      );

  /* STEP 3 */
  const step3Active =
    audition?.result &&
    audition?.result !== 'Pending';

  return (
    <div className="dashboard-bms-card-outer">
      <Link to={`/audition/${audition?.id}/${audition?.urlSlug || 'details'}`} className="text-decoration-none">
        <Card className="dashboard-bms-audition-card h-100">
          {/* <div className="dashboard-bms-image-wrapper">
            <img src={audition?.projectImageUrl} alt={audition?.projectName} className="dashboard-bms-card-image" />
          </div> */}
          <div className="dashboard-bms-strip-bar">
            {/* <div className="dashboard-bms-strip-left">
              {(audition?.auditionType ? audition.auditionType.split(';') : ['Online']).map((type, index) => (
                <span key={index} className="dashboard-bms-strip-type-badge">{type}</span>
              ))}
            </div> */}
            <div className="dashboard-bms-strip-left">

            <span className="dashboard-bms-strip-type-badge">

              {audition?.booking_type === 'SLOT_BOOKING'
                ? 'WALK IN'
                : audition?.booking_type === 'VIDEO_UPLOAD'
                ? 'ONLINE'
                : 'AUDITION'}

            </span>

          </div>
            <div className="dashboard-bms-strip-right">
              {audition?.roleCategory || audition?.projectType || 'Audition'}
            </div>
          </div>

          <div className="dashboard-bms-image-wrapper">
            <img src={audition?.projectImageUrl} alt={audition?.projectName} className="dashboard-bms-card-image" />
            <div className="dashboard-bms-image-bottom-info dashboard-bms-image-bottom-info-only-amount">
              <div className="dashboard-bms-image-amount">
                ₹{Number(audition?.totalAmount || audition?.price || audition?.finalAmount || audition?.final_amount || 0).toFixed(2)}
              </div>
            </div>
          </div>
          <Card.Body>
            <h5 className="dashboard-bms-project-title">{audition?.projectName}</h5>
            <p className="dashboard-bms-role-title">{audition?.roleTitle}</p>

          <div className="dashboard-bms-wizard dashboard-bms-bottom-wizard">

            {/* STEP 1 */}

            <div
              className={`dashboard-step ${
                step1Active ? 'active' : ''
              }`}
            >

              <span className="dashboard-step-dot"></span>

              <span className="dashboard-step-text">
                Book
              </span>

            </div>

            {/* LINE */}

            <div
              className={`dashboard-step-line ${
                step2Active ? 'active' : ''
              }`}
            ></div>

            {/* STEP 2 */}

            <div
              className={`dashboard-step ${
                step2Active ? 'active' : ''
              }`}
            >

              <span className="dashboard-step-dot"></span>

              <span className="dashboard-step-text">

                {isWalkIn
                  ? 'Interview'
                  : 'Upload'}

              </span>

            </div>

            {/* LINE */}

            <div
              className={`dashboard-step-line ${
                step3Active ? 'active' : ''
              }`}
            ></div>

            {/* STEP 3 */}

            <div
              className={`dashboard-step ${
                step3Active ? 'active' : ''
              }`}
            >

              <span className="dashboard-step-dot"></span>

              <span className="dashboard-step-text">
                Status
              </span>

            </div>

          </div>

            <div className="dashboard-result-wrap">
              <Badge pill className={getResultClassName(audition?.result)}>
                {audition?.result || 'Pending'}
              </Badge>
            </div>
          </Card.Body>
        </Card>
      </Link>
      
      {/* Share Logic */}
      {/* <div onClick={stopOnly}>
        <Dropdown show={showShare} onToggle={setShowShare} align="end">
          <Dropdown.Toggle as="button" className="dashboard-share-toggle"><FaShareAlt size={14} /></Dropdown.Toggle>
          <Dropdown.Menu>
            <div className="d-flex gap-3 p-2">
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}`} target="_blank" rel="noreferrer"><FaFacebook color="#1877F2" /></a>
              <a href={`https://twitter.com/intent/tweet`} target="_blank" rel="noreferrer"><FaTwitter color="#1DA1F2" /></a>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}
    </div>
  );
};